import React, { Fragment } from 'react';
import { Box, Typography } from '@mui/material';
import { AzulIconButton } from '@the-ksquare-group/azul-ds';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Button from 'components/Button/Button';
import { colorPalette, docGeniusPalette } from 'styles/partials/colors';
import { ModalProps } from '../ModalFactory';
import { useRestoreDocumentVersionMutation } from 'features/document/documentApi';
import { useRestoreDocumentTemplateVersionMutation } from 'features/template/templateApi';

export default function RestoreModalContent(props: ModalProps) {
  const { onClose, modalData } = props;
  const { id, documentId, isTemplate } = modalData;
  const [restoreDocument] = useRestoreDocumentVersionMutation();
  const [restoreDocumentTemplateVersion] = useRestoreDocumentTemplateVersionMutation();

  return (
    <Fragment>
      <Box sx={{ position: 'absolute', right: ' 20px', top: '29px' }}>
        <AzulIconButton
          icon={<CloseRoundedIcon sx={{ color: colorPalette.primaryBlue }} />}
          tooltipTitle='Close'
          onClick={onClose}
        />
      </Box>
      <Typography
        id='modal-modal-title'
        variant='h6'
        component='h2'
        fontSize='24px'
        sx={{ color: docGeniusPalette.neutralGray }}
      >
        Restore this version?
      </Typography>
      <Typography id='modal-modal-description' sx={{ mt: 2 }}>
        Your current file will change to the version {modalData.versionDate}
      </Typography>
      <Box sx={{ marginTop: '80px' }} />
      <Box
        sx={{
          display: 'flex',
          position: 'absolute',
          bottom: '33px',
          right: '32px',
        }}
      >
        <Button variant='secondary' onClick={onClose}>
          Cancel
        </Button>
        <Box sx={{ marginRight: '20px' }} />
        <Button
          onClick={async () => {
            if (isTemplate) {
              restoreDocumentTemplateVersion({
                id,
                documentTemplateId: documentId,
                isTemplate,
              });
            } else {
              await restoreDocument({
                id,
                documentId,
                isTemplate,
              });
            }
            onClose();
          }}
        >
          Restore
        </Button>
      </Box>
    </Fragment>
  );
}

